// extracted by mini-css-extract-plugin
export default {"credentialValue":"CopiableText_credentialValue__VySZX"};